import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useParams } from "react-router-dom";

export const RadarViewProfileContext = createContext(null);

type Props = {
  children: ReactElement;
};

const RadarViewProfileProvider: FunctionComponent<Props> = ({ children }) => {
  const { id } = useParams();

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["radar_view_profile_user"],
    // staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`onboarding/profiles/${id}`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <RadarViewProfileContext.Provider value={contextValue}>
      {children}
    </RadarViewProfileContext.Provider>
  );
};

export default RadarViewProfileProvider;
